<template>
  <div>
    <label class="block font-semibold">{{ label }} <span class="text-red-500" v-if="required">*</span>
      <input :type="type" :placeholder="placeholder" :maxlength="maxlength" :disabled="disabled"
             :min="type==='date'?minDate:min" :step="step" :max="type==='date'?maxDate:max"
             class="block w-full py-1 px-3 pr-5 mt-1 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
             v-on:input="$emit('input', $event.target.value)" v-bind:value="value" @blur="$emit('blur', $event)"
             @keyup="$emit('keyup',$event)" @keypress="$emit('keypress',$event)" @keydown="$emit('keydown',$event)"
             :class="state===false? 'border-red-500':state===true?'border-green-500':'focus:border-gray-200'?errorborder===true?'border-red-500':'':null"/>
      <span class="flex items-center tracking-wide text-xs mt-1 ml-1"
            :class="state===true?'text-green-500':'text-red-500'"
            v-if="state!==null">
			          {{ state === true ? validMessage : errorMessage }}
		        </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "inputcomponent",
  props: {
    parten: {
      type: String
    },
    step: {
      type: Number
    },
    maxlength: {
      type: Number,
    },
    max: {
      type: Number
    },
    min: {
      type: Number
    },
    maxDate: {
      type: String,
      default: () => new Date().toJSON().slice(0, 10)
    },
    minDate: {
      type: String
    },
    value: null,
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    state: {
      default: null
    },
    errorMessage: {
      type: String,
      default: 'No correcto '
    },
    validMessage: {
      type: String,
      default: 'Valido'
    },
    errorborder: {
      type: Boolean,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>